__turbopack_context__.v({
  "articleSection": "RichText-module__Nn2vGa__articleSection",
  "richText": "RichText-module__Nn2vGa__richText",
  "singleImage": "RichText-module__Nn2vGa__singleImage",
});
